import React from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import Icon from "./Icon";
import { CustomSubtitle, CustomChartsTitle } from "./Custom/CustomTypography";
import { useNavigate } from "react-router-dom";
import { useAlert } from "./Alert";

const QuickLinks = ({ data, farmerStatus }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  const handleClick = (route, isEnabled) => {
    if (!isEnabled) {
      showAlert(
        "warning",
        "You need to complete the specific stage to access this feature."
      );
      return;
    }
    navigate(route);
  };

  const isLinkEnabled = (type, farmerStatus) => {
    switch (type) {
      case "myCropQL":
        return (
          farmerStatus &&
          farmerStatus.stages &&
          farmerStatus.stages.some(
            (stage) => stage.stage_name === "Add Crop" && stage.complete
          )
        );
      case "inputSupplyQL":
        return (
          farmerStatus &&
          farmerStatus.stages &&
          farmerStatus.stages.some(
            (stage) => stage.stage_name === "Add Input Supply" && stage.complete
          )
        );
      case "myHarvestQL":
        return (
          farmerStatus &&
          farmerStatus.stages &&
          farmerStatus.stages.some(
            (stage) => stage.stage_name === "Add Harvest" && stage.complete
          )
        );
      default:
        return true;
    }
  };

  return (
    <div style={{ padding: "10px 0" }}>
      <CustomChartsTitle>{t("Quick Links")}</CustomChartsTitle>
      <div
        style={{
          backgroundColor: "white",
          padding: "20px 10px",
          borderRadius: "4px",
          boxShadow: "0px -3px 4.2px 0px #E3E3E340",
          margin: "15px 0",
        }}
      >
        <Grid container spacing={1.5}>
          {data.map((item, index) => {
            const isEnabled = isLinkEnabled(item.type, farmerStatus);

            return (
              <Grid
                item
                xs={3}
                key={index}
                container
                direction="column"
                alignItems="center"
                padding="0"
                onClick={() => handleClick(item.route, isEnabled)}
                style={{ cursor: isEnabled ? "pointer" : "not-allowed" }}
              >
                <Icon type={item.type} />
                <div style={{ marginTop: "5px" }}>
                  <CustomSubtitle>{item.label}</CustomSubtitle>
                </div>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
};

export default QuickLinks;
